import { Pipe, PipeTransform } from '@angular/core';
import { getMutableReadOnlyEntity } from '@myia/ngx-core';

@Pipe({ name: 'mutableArray' })
export class MutableArrayPipe implements PipeTransform {
  transform<T>(value: ReadonlyArray<T> | undefined | null): Array<T> | undefined | null {
    return value ? getMutableReadOnlyEntity(value) as Array<T> : value;
  }
}
